import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Header from './components/Header';
import Home from './components/Home';
import ContactSection from './components/ContactSection';
import JuryPolicy from './components/JuryPolicy';
import WinnersPage from './components/WinnersPage';
import OrganizerPage from './components/OrganizerPage';
import JuryByYear from './components/JuryByYear';
import TermsPage from './components/TermsPage';
import NominationsPage from './components/NominationsPage';
import ArticlesList from './components/ArticlesList';
import Article from './components/Article';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/jury" element={<JuryPolicy />} />
          <Route path="/winners" element={<WinnersPage />} />
          <Route path="/organizer" element={<OrganizerPage />} />
          <Route path="/jurylist" element={<JuryByYear />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/nominations" element={<NominationsPage />} />
          <Route path="/articles" element={<ArticlesList />} />
          <Route path="/articles/:id" element={<Article />} />
        </Routes>
        <ContactSection />
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;